import { BEWalletTypeFormat } from "types/wallets";
import { boolean, number, object, string } from "yup";

const walletJson = object({
  code: string().required(),
  active: boolean().required(),
  limits: object({
    points: object({
      interval: object({
        type: string(),
        value: number(),
      }),
      value: number(),
    }),
    pointsPerMember: object({
      interval: object({
        type: string(),
        value: number(),
      }),
      value: number(),
    }),
  }),
  translations: object().required(),
  unitDaysExpiryAfter: string().required(),
  unitDaysActiveCount: number(),
  unitPluralName: string().required(),
  unitSingularName: string().required(),
  walletTypeId: string(),
  allTimeNotLocked: boolean().required(),
  allowNegativeBalance: boolean().required(),
  unitDaysLocked: number(),
  unitYearsActiveCount: number(),
  unitExpiryDate: string(),
});

export const isWalletJsonValid = (wallet: BEWalletTypeFormat) => {
  try {
    walletJson.validateSync(wallet);
    return true;
  } catch {
    return false;
  }
};
